import { render, staticRenderFns } from "./MaterialLibrary.vue?vue&type=template&id=5324201b&scoped=true"
import script from "./MaterialLibrary.vue?vue&type=script&lang=js"
export * from "./MaterialLibrary.vue?vue&type=script&lang=js"
import style0 from "./MaterialLibrary.vue?vue&type=style&index=0&id=5324201b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5324201b",
  null
  
)

export default component.exports